// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: site assistant conversations in the staff admin console (routes/AdminAssistant.tsx). Merged into the catalog by messages.en.ts. */
export const adminAssistant = {
  "admin.tab.chats": "Chats",
  "admin.chats.description": "Conversations with the assistant chat on granite.md, kept for 90 days. A conversation is one visitor's browser tab.",
  "admin.chats.show": "Show",
  "admin.chats.filter.all": "All",
  "admin.chats.filter.handover": "Handed over",
  "admin.chats.stat.conversations": "Conversations",
  "admin.chats.stat.questions": "Questions",
  "admin.chats.stat.handovers": "Handed over",
  "admin.chats.stat.today": "Questions, last 24 h",
  "admin.chats.col.conversation": "First question and last answer",
  "admin.chats.col.turns": "Questions",
  "admin.chats.col.source": "Source",
  "admin.chats.col.ip": "IP",
  "admin.chats.status.handover": "Handed over",
  "admin.chats.status.answered": "Answered",
  "admin.chats.status.offTopic": "Off topic",
  "admin.chats.title": "Conversation",
  "admin.chats.started": "Started {date}",
  "admin.chats.visitor": "Visitor",
  "admin.chats.assistant": "Assistant",
  "admin.chats.links": "Links shown",
  "admin.chats.details": "Details",
  "admin.chats.source": "Source",
  "admin.chats.referrer": "Came from",
  "admin.chats.page": "First page",
  "admin.chats.ip": "IP address",
  "admin.chats.browser": "Browser",
  "admin.chats.direct": "No referring site",
} as const;
